/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {HISTORY_EVENT_ICON_BY_ASSET} from '../maps/constants';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Stop Icon component.
 */
export const StopIcon = (props: IconProps) => {
  const {iconSize} = useIconDLS(props);
  const {stop}     = HISTORY_EVENT_ICON_BY_ASSET;

  return (
    <ThemeIconProvider name='StopIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M0.5 7.50098C0.5 3.63498 3.63401 0.500977 7.5 0.500977C11.366 0.500977 14.5 3.63498 14.5 7.50098C14.5 11.367 11.366 14.501 7.5 14.501C3.63401 14.501 0.499999 11.367 0.5 7.50098Z' fill={stop.color} stroke='white'/>
        <rect x='4.16384' y='4.96191' width='1.12748' height='8.84045' rx='0.563742' transform='rotate(-45 4.16384 4.96191)' fill='white' stroke='white' strokeWidth='0.3'/>
        <rect x='0.212132' width='1.12748' height='8.84045' rx='0.563742' transform='matrix(-0.707107 -0.707107 -0.707107 0.707107 11.3621 5.11191)' fill='white' stroke='white' strokeWidth='0.3'/>
      </svg>
    )} />
  );
};
